import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, opacity = 1, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}`}
    width={`${size}`}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g fill="none" opacity={opacity} stroke={color} strokeWidth="2">
      <path clipRule="evenodd" d="m11.9999 20-5-7c-2.5-4 .6061-9 5-9s7.5 5 5 9l-5 7Z" strokeLinejoin="round" />
      <circle cx="12" cy="10" r="2" />
    </g>
  </svg>
);
